import {CheckedItemPosition, ListOptions} from "../ClientSidetypes";
import {ChangeEvent} from "react";

export default function ListOptionsMenu(
    {
        currentOptions,
        onChange,
        removeAllCheckedItems,
        removeAllItems,
        removeList,
        hasBeenRemoved,
    } : {
        currentOptions: ListOptions
        onChange: (newListOptions: ListOptions) => void
        removeAllCheckedItems: () => void
        removeAllItems: () => void
        removeList: () => void
        hasBeenRemoved: boolean
    }) {


    const radioButtonChange = (event: ChangeEvent<HTMLInputElement>) => {
        onChange({...currentOptions, checkedItemPosition: event.target.value} as ListOptions);
    };

    const updateGroupByTypeOption = (event: ChangeEvent<HTMLInputElement>) => {
        onChange({...currentOptions, groupByType: event.target.checked});
    };

    const updatePlaySoundWhenCheckedAndUncheked = (event: ChangeEvent<HTMLInputElement>) => {
        onChange({...currentOptions, playSoundWhenCheckedAndUncheked: event.target.checked});
    };

    return (
        <>
            <menu id={"list-options"}>
                <ul>
                    <li>
                        <label>
                            <input disabled={hasBeenRemoved} type={"checkbox"} checked={currentOptions.groupByType} onChange={updateGroupByTypeOption} />
                            Gruppera på typ
                        </label>
                    </li>
                    <li>
                        <label>
                            <input disabled={hasBeenRemoved} type={"checkbox"} checked={currentOptions.playSoundWhenCheckedAndUncheked} onChange={updatePlaySoundWhenCheckedAndUncheked} />
                            Spela ljud när bokad/avbokad
                        </label>
                    </li>
                    <li>
                        <button disabled={hasBeenRemoved} onClick={() => removeAllCheckedItems()}>
                            Ta bort alla avbockade
                        </button>
                    </li>
                    <li>
                        <button disabled={hasBeenRemoved} onClick={() => removeAllItems()}>
                            Ta bort allt i listan
                        </button>
                    </li>
                    <li>
                        <button onClick={() => removeList()}>
                            Ta bort listan
                        </button>
                    </li>
                </ul>
                <fieldset>
                    <legend>Avbockade</legend>
                    <ul>
                        <li>
                            <label>
                                <input
                                    type={"radio"}
                                    name={"checkedItemPosition"}
                                    value={CheckedItemPosition.InPlace}
                                    onChange={radioButtonChange}
                                    checked={currentOptions.checkedItemPosition === CheckedItemPosition.InPlace}
                                />
                                lämnas på sin plats
                            </label>
                        </li>
                        <li>
                            <label>
                                <input
                                    type={"radio"}
                                    name={"checkedItemPosition"}
                                    value={CheckedItemPosition.EndOfList}
                                    onChange={radioButtonChange}
                                    checked={currentOptions.checkedItemPosition === CheckedItemPosition.EndOfList}
                                />
                                flyttas till slutet av listan
                            </label>
                        </li>
                        <li>
                            <label>
                                <input
                                    type={"radio"}
                                    name={"checkedItemPosition"}
                                    value={CheckedItemPosition.CheckedItemsList}
                                    onChange={radioButtonChange}
                                    checked={currentOptions.checkedItemPosition === CheckedItemPosition.CheckedItemsList}
                                />
                                flyttas till egen lista under listan
                            </label>
                        </li>
                    </ul>
                </fieldset>
            </menu>
        </>
    );
}
